import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Loader from "@/components/app/Loader";

export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (sessionId) {
        try {
          await completeGoogle(sessionId);
        } catch (e) {
          console.error("google session completion failed", e);
        }
      }
      // limpa o fragmento da URL e vai para o app
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/app", { replace: true });
    })();
  }, []);

  return <Loader text="Entrando com Google..." />;
}
